export default __webpack_public_path__ + "static/media/logoOnb.12826155.png";